export default "__VITE_ASSET__efikg6yZ__"